import IBAN from 'iban'

export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const validatorIban = iban => IBAN.isValid(iban)

export const validatorUID = uid => {
  /* eslint-disable no-useless-escape */
  let regExp = /^(ATU[0-9]{8}$)/
  /* eslint-enable no-useless-escape */
  let validUID = regExp.test(uid)

  if (validUID === true) {
    return validUID
  }

  regExp = /^\d{9}$/
  validUID = regExp.test(uid)

  return validUID
}

export const isDateASmallerThanDateB = (dateA, dateB) => {
  // Convert date strings to Date objects
  const parsedDateA = new Date(dateA)
  const parsedDateB = new Date(dateB.dateB)
  // Compare the dates
  return parsedDateA < parsedDateB
}
